// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../../Config.bs.js";
import * as NetworkUtils from "../../../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as CreateCommentRequest from "../../entity/CreateCommentRequest.bs.js";
import * as AutoCreateTicketRequest from "../../entity/AutoCreateTicketRequest.bs.js";
import * as TicketingOrderRepoConfig from "./TicketingOrderRepoConfig.bs.js";
import * as PartnerGoodwillDiscountPayload from "../../entity/PartnerGoodwillDiscountPayload.bs.js";

function fetchInstaMojoDetails(orderId, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/orders/instamojo_payment_records?order_id=" + orderId);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.InstaMojoResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderLogs(orderId, offset, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v3/orders/order_logs/" + (orderId + ("/" + offset)));
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderLogsJsonResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchTicketsForOrder(orderId, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/ticketing/tickets_for_order?order_id=" + orderId);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.TicketsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrder(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v4/orders/order_details?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderSchedule(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/schedule/" + order_id + "/order");
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderScheduleConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderFare(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v4/orders/order_fare_and_payment_details?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderFareResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderComments(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v4/orders/comments/get?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderCommentsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderTickets(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/ticketing/tickets_for_order?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderTicketsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function createOrderComments(params, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v4/orders/comments/create";
  var payload_string = JSON.stringify(CreateCommentRequest.t_encode(params));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payload_string, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.CreateCommentResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchPartnerEarnings(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v4/orders/earning_details?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.PartnerEarningsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderFareBreakup(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v4/orders/order_fare_details?order_id=" + order_id);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderFareV2ResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function createPartnerGoodwillDiscount(payload, country) {
  var payloadString = JSON.stringify(PartnerGoodwillDiscountPayload.t_encode(payload));
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/payout/disburse_goodwill";
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.PartnerGoodwillDIscountConverter.execute, result);
                            });
                }), requestUrl);
}

function createTicket(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/ticketing/create_ticket_basic";
  var encodedPayload = JSON.stringify(AutoCreateTicketRequest.t_encode(payload));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.AutoCreateTicketJsonResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var TicketingOrderRepo = {
  fetchInstaMojoDetails: fetchInstaMojoDetails,
  fetchOrderLogs: fetchOrderLogs,
  fetchTicketsForOrder: fetchTicketsForOrder,
  fetchOrder: fetchOrder,
  fetchOrderSchedule: fetchOrderSchedule,
  fetchOrderComments: fetchOrderComments,
  createOrderComments: createOrderComments,
  fetchOrderTickets: fetchOrderTickets,
  fetchOrderFare: fetchOrderFare,
  fetchPartnerEarnings: fetchPartnerEarnings,
  fetchOrderFareBreakup: fetchOrderFareBreakup,
  createPartnerGoodwillDiscount: createPartnerGoodwillDiscount,
  createTicket: createTicket
};

export {
  TicketingOrderRepo ,
  
}
/* Config Not a pure module */
